import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRightIcon, CheckIcon, CreditCardIcon, HeadphonesIcon, MailIcon, PackageIcon, PhoneIcon, TruckIcon } from "lucide-react";
import { Logo } from "./Logo";
import { store } from "../data/store";
const promises = [{
  icon: PackageIcon,
  title: "Discreet packaging",
  text: "Plain box, no branding"
}, {
  icon: TruckIcon,
  title: "Fast EU delivery",
  text: "Shipped from the Netherlands"
}, {
  icon: CreditCardIcon,
  title: "Secure payment",
  text: "Encrypted checkout"
}, {
  icon: HeadphonesIcon,
  title: "Personal support",
  text: "Real people, fast answers"
}];
const columns = [{
  title: "Shop",
  links: [{
    label: "All products",
    to: "/shop"
  }, {
    label: "Honey & Choco",
    to: "/shop?collection=royal-honey"
  }, {
    label: "Seven Sins",
    to: "/shop?collection=seven-sins"
  }, {
    label: "Devils Candy",
    to: "/shop?collection=devils-candy"
  }, {
    label: "High Octane",
    to: "/shop?collection=high-octane"
  }]
}, {
  title: "Help",
  links: [{
    label: "Shipping & returns",
    to: "/"
  }, {
    label: "FAQ",
    to: "/"
  }, {
    label: "Privacy policy",
    to: "/"
  }, {
    label: "Terms & conditions",
    to: "/"
  }]
}];
export function Footer() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<"idle" | "error" | "success">("idle");
  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setStatus(/^\S+@\S+\.\S+$/.test(email) ? "success" : "error");
  };
  return <footer className="border-t border-line bg-night" data-id="element-85" data-mp="31umvaqetzm7">
      <ul className="mx-auto grid max-w-7xl grid-cols-2 border-b border-line lg:grid-cols-4" aria-label="Our promises" data-id="element-86" data-mp="hrs7jgp4s76n">
        {promises.map(({
        icon: Icon,
        title,
        text
      }) => <li key={title} className="flex items-center gap-3 px-6 py-6" data-id="element-87" data-mp="qt051wjtp3zo">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-raised" data-id="element-88" data-mp="mrwpzc9lnbzi">
              <Icon className="h-5 w-5 text-brand" aria-hidden="true" data-id="element-89" data-mp="tvczjrxji5f5" />
            </span>
            <div data-id="element-90" data-mp="yu7fmm44hfvk">
              <p className="text-sm font-semibold" data-id="element-91" data-mp="yto901jxadwu">{title}</p>
              <p className="text-xs text-subtle" data-id="element-92" data-mp="ys3g0gd9b313">{text}</p>
            </div>
          </li>)}
      </ul>
      <div className="mx-auto max-w-7xl px-6 py-16 lg:py-20" data-id="element-93" data-mp="13rfy6nt6nlxc">
        <div className="grid gap-12 lg:grid-cols-12" data-id="element-94" data-mp="18ksl8ti7rknz">
          <div className="lg:col-span-5" data-id="element-95" data-mp="1clunlj7fgcu6">
            <Logo showTagline data-id="element-96" data-mp="1ckt3yqccii0u" />
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-muted" data-id="element-97" data-mp="1cnyqbxtlb5sv">
              A range of premium products designed to elevate pleasure, passion and performance. Shipped discreetly
              from the Netherlands.
            </p>
            <form onSubmit={onSubmit} className="mt-8 max-w-sm" noValidate data-id="element-98" data-mp="1rj4v6hgy8ykm">
              <label htmlFor="newsletter" className="text-sm font-semibold" data-id="element-99" data-mp="3obevtoarh49r">
                Join the list for drops and offers
              </label>
              {status === "success" ? <p className="mt-3 flex items-center gap-2 text-sm text-brand" data-id="element-100" data-mp="2af3ubumo9blq">
                  <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-101" data-mp="2agyeh6q4czor" /> You're on the list.
                </p> : <>
                  <div className="mt-3 flex rounded-full border border-line bg-surface p-1 focus-within:border-white/40" data-id="element-102" data-mp="21nv5bamib8zx">
                    <input id="newsletter" type="email" value={email} onChange={e => {
                  setEmail(e.target.value);
                  setStatus("idle");
                }} placeholder="Your email address" className="min-w-0 flex-1 bg-transparent px-4 text-sm placeholder:text-subtle focus:outline-none" aria-invalid={status === "error"} aria-describedby={status === "error" ? "newsletter-error" : undefined} data-id="element-103" data-mp="1wpa3x7viqj9w" />
                    <button type="submit" className="rounded-full bg-brand p-2.5 text-night transition-colors hover:bg-brand-dark" aria-label="Subscribe" data-id="element-104" data-mp="2rvr518btgcc6">
                      <ArrowRightIcon className="h-4 w-4" data-id="element-105" data-mp="2iwci2iuuyjwf" />
                    </button>
                  </div>
                  {status === "error" && <p id="newsletter-error" className="mt-2 text-xs text-ember" data-id="element-106" data-mp="3bjqhcnm13rjp">
                      Please enter a valid email address.
                    </p>}
                </>}
            </form>
          </div>

          {columns.map(col => <nav key={col.title} aria-label={col.title} className="lg:col-span-2" data-id="element-107" data-mp="31nww8fu8upqb">
              <h2 className="text-sm font-semibold" data-id="element-108" data-mp="36mqd8i8qoyv8">{col.title}</h2>
              <ul className="mt-4 space-y-3" data-id="element-109" data-mp="1q5m4fwlhhpaz">
                {col.links.map(link => <li key={link.label} data-id="element-110" data-mp="1v6i603id4zd8">
                    <Link to={link.to} className="text-sm text-muted transition-colors hover:text-white" data-id="element-111" data-mp="1v3dwcqm4pbf6">
                      {link.label}
                    </Link>
                  </li>)}
              </ul>
            </nav>)}

          <div className="lg:col-span-3" data-id="element-112" data-mp="1wlkw71spb8sr">
            <h2 className="text-sm font-semibold" data-id="element-113" data-mp="1wkjisqo7qa7v">Contact</h2>
            <ul className="mt-4 space-y-3 text-sm" data-id="element-114" data-mp="1rom1oi54kzu1">
              <li data-id="element-115" data-mp="13xyih0prens6">
                <a href={`mailto:${store.email}`} className="inline-flex items-center gap-2 text-muted transition-colors hover:text-white" data-id="element-116" data-mp="13xgqwhe1kxql">
                  <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-117" data-mp="1dni58hglf1sb" /> {store.email}
                </a>
              </li>
              <li data-id="element-118" data-mp="18w0cuhsmy9iy">
                <a href={store.phoneHref} className="inline-flex items-center gap-2 text-muted transition-colors hover:text-white" data-id="element-119" data-mp="18vi80wrwqmzf">
                  <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-120" data-mp="g7cizxttmbts" /> {store.phone}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 flex flex-col gap-4 border-t border-line pt-8 text-xs text-subtle md:flex-row md:items-center md:justify-between" data-id="element-121" data-mp="2l9gpq5n7py5p">
          <p data-id="element-122" data-mp="2q0ypwrhevupm">© 2026 Rise-Upp. All rights reserved. For adults 18+ only.</p>
          <p className="max-w-xl md:text-right" data-id="element-123" data-mp="2uzt8ptfdpj9q">
            Food supplements are not a substitute for a varied, balanced diet and a healthy lifestyle.
          </p>
        </div>
      </div>
    </footer>;
}